import React, { useEffect, useState, useLayoutEffect } from "react";
import { getDoc, doc } from "firebase/firestore";
import { db } from "../config/fbconfig";
import { useLocation } from "react-router-dom";
import PageTitle from "../banner";
import moment from "moment";
import { useHistory } from "react-router-dom";

function BlogDeatils(props) {
  const history = useHistory();
  const location = useLocation();
  const { Id } = location.state || {}; // Retrieving category from state
  const [formattedData, setFormattedData] = useState([]);

  console.log(formattedData);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const docRef = doc(db, "Other", "Blog");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const fetchedData = Object.entries(docSnap.data()).map(
            ([key, value]) => {
              const date = new Date(
                value.Date.seconds * 1000 + value.Date.nanoseconds / 1000000
              );
              return {
                Id: key,
                ...value,
                formattedDate: date.toLocaleString(),
              };
            }
          );
          setFormattedData(fetchedData.sort((a, b) => a.Priority - b.Priority));
        } else {
          setFormattedData([]);
        }
      } catch (error) {
        console.error("Error fetching blogs: ", error);
      }
    };
    fetchBlogs();
  }, []);

  const data = formattedData?.find((event) => event.Id === Id);

  console.log(data);

  const getInitialBgImage = () =>
    window.innerWidth <= 768
      ? "img/about/blogmb.jpg"
      : "img/about/banner03.jpg";

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [bgImage, setBgImage] = useState(getInitialBgImage);

  useLayoutEffect(() => {
    const handleResize = () => {
      setBgImage(
        window.innerWidth <= 768
          ? "img/about/blogmb.jpg"
          : "img/about/banner03.jpg"
      );
      setIsMobile(window.innerWidth <= 768);
    };

    const debounceResize = debounce(handleResize, 100);

    window.addEventListener("resize", debounceResize);
    return () => {
      window.removeEventListener("resize", debounceResize);
    };
  }, []);

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  const embedUrl = "https://www.youtube.com/embed/" + data?.Video.split("=")[1];

  const handleGoBack = () => {
    history.goBack(); // Navigates to the previous page in the history stack
  };

  return (
    <div>
      <div style={{ marginBottom: "5rem" }}>
        <PageTitle desc={"Blog"} img={bgImage} />
      </div>
      <div
        className="container"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div>
          <button
            style={{
              padding: "8px",
              borderRadius: "4px",
            }}
            onClick={handleGoBack}
            className="site-btn"
          >
            Go Back
          </button>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              style={{ height: "400px", borderRadius: "12px" }}
              src={data?.Image}
            />
          </div>
          <h5
            style={{
              fontWeight: "bold",
              marginTop: "1.5rem",
            }}
          >
            {data?.Header}
          </h5>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "0.5rem",
              alignItems: "center",
              marginTop: "1rem",
            }}
          >
            <div>
              by &nbsp;
              <span style={{ fontWeight: "bold", fontSize: "13px" }}>
                Nagesh Murthy
              </span>
            </div>
            <div>
              <p
                style={{
                  fontWeight: "bold",
                  fontSize: "13px",
                  color: "#111111",
                }}
              >
                Date : {moment(data?.formattedDate).format("MM/DD/YYYY")}
              </p>
            </div>
          </div>
          <div>
            <p style={{ textAlign: "justify", marginBottom: "1rem" }}>
              {data?.Description}
            </p>
          </div>
          {data?.Video !== "" && (
            <div className="card blog blog-primary border-0 shadow rounded overflow-hidden">
              <iframe
                style={{ height: "400px" }}
                className="embedded-video-16-"
                src={embedUrl}
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          )}

          <div style={{ marginTop: "1.5rem" }}>
            <p style={{ textAlign: "justify" }}>{data?.Description1}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BlogDeatils;
